import React from 'react';
import styled from '@emotion/styled';
import { BodyTextSmall } from '@modernhealth/vital-components';
import { color } from 'src/shared/styles/variables';

interface Props {
    data: string[][];
}

const Table = styled.div({
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
    fontSize: 16,
    paddingLeft: 15,
    paddingRight: 15,
    backgroundColor: color.gray05,
});

const Row = styled.div({
    display: 'flex',
    alignSelf: 'stretch',
    flexDirection: 'row',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingTop: 10,
    paddingBottom: 10,
    borderBottom: `1px solid ${color.gray10}`,
});

const LastRow = styled.div({
    display: 'flex',
    alignSelf: 'stretch',
    flexDirection: 'row',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingTop: 10,
    paddingBottom: 10,
});

const FirstCell = styled(BodyTextSmall)({
    flex: 1,
    marginBottom: 0,
    alignItems: 'flex-start',
});

const SecondCell = styled(BodyTextSmall)({
    alignItems: 'flex-end',
});

export const CostModalTable: React.FC<Props> = ({ data }) => {
    return (
        <Table>
            {data.map((row, i) => {
                if (!row) {
                    return;
                }
                const rowContent = (
                    <>
                        <FirstCell>{row[0]}</FirstCell>
                        <SecondCell>{row[1]}</SecondCell>{' '}
                    </>
                );
                if (i === data.length - 1) {
                    return <LastRow key={i}>{rowContent}</LastRow>;
                }
                return <Row key={i}>{rowContent}</Row>;
            })}
        </Table>
    );
};
